const NOTIFICATION_STATUSES = {
  OPEN: 'open',
  RESOLVED: 'resolved',
};

export { NOTIFICATION_STATUSES };
